import { NgModule } from '@angular/core';
import { FilterByPipe } from './filter-by.pipe';

@NgModule({
    declarations: [FilterByPipe],
    exports: [FilterByPipe],
})
export class FilterByPipeModule {}
